<template>
    <div class="container pb-4 company-list-tab">
        <div class="row mb-5" style="margin-top: 50px">
            <div class="col-12">
                <div class="company-list-tab__title">Following Company</div>
                <div class="company-list-tab__desc">
                    View how companies are working remotely, get ideas and stay
                    up to date on their feed
                </div>
            </div>
        </div>
        <div class="tab-content">
            <div class="tab-pane fade show active">
                <ul
                    class="nav justify-content-center py-4 mx-auto"
                    style="max-width: 768px"
                >
                    <li class="nav-item col-6 p-0">
                        <a
                            class="nav-link"
                            v-bind:class="{
                                active: this.page === 'companies-list'
                            }"
                            href="javascript:void(0);"
                            @click="changePage('companies-list')"
                        >
                            Companies
                        </a>
                    </li>
                    <li class="nav-item col-6 p-0">
                        <a
                            class="nav-link"
                            v-bind:class="{ active: this.page === 'following' }"
                            href="javascript:void(0);"
                            @click="changePage('following')"
                        >
                            Following
                        </a>
                    </li>
                </ul>
                <div class="tab-content">
                    <div
                        class="tab-pane fade"
                        v-bind:class="{
                            show: this.page === 'companies-list',
                            active: this.page === 'companies-list'
                        }"
                    >
                        <companies-list
                            v-if="this.page === 'companies-list'"
                            :origin="origin"
                            v-on:viewCompanyDetails="viewCompanyDetails"
                        ></companies-list>
                    </div>
                    <div
                        class="tab-pane fade"
                        v-bind:class="{
                            show: this.page === 'following',
                            active: this.page === 'following'
                        }"
                    >
                        <companies-list
                            v-if="this.page === 'following'"
                            :origin="origin"
                            :only_following="true"
                            v-on:viewCompanyDetails="viewCompanyDetails"
                        ></companies-list>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ["auth", "origin"],

    data() {
        return {
            total_companies: 0,
            total_employees: 0,
            page: "companies-list"
        };
    },

    computed: {
        totalCompaniesWithEmployeesText() {
            if (this.total_companies == 1)
                return (
                    this.total_companies +
                    " company with " +
                    this.total_employees +
                    " employees"
                );

            return (
                this.total_companies +
                " companies with " +
                this.total_employees +
                " employees"
            );
        }
    },

    methods: {
        changePage(page) {
            this.page = page;
            window.location.hash = `#${page}`;
        },

      async getTotalCompaniesAndEmployees () {
        const data = await axios.get('/company/total-companies-employees').then(data => data.data.data);

        this.total_companies = data['total_companies'];
        this.total_employees = data['total_employees'];
      },

        viewCompanyDetails(companyId) {
            window.scrollTo(0, 0);
            this.$emit("viewCompanyDetails", companyId);
        }
    },

    mounted() {
        this.getTotalCompaniesAndEmployees();

        if (window.location.hash.substr(1)) {
            this.page = window.location.hash.substr(1);
        }
    }
};
</script>

<style lang="scss" scoped>
.company-list-tab {
    &__title {
        color: #303030;
        font-family: Lato;
        font-size: 38px;
        font-weight: bold;
        letter-spacing: 0;
        line-height: 60px;
        text-align: center;
        @media (max-width: 768px) {
            text-align: left;
            font-size: 24px;
            font-family: "Open Sans", sans-serif;
        }
    }

    &__desc {
        color: #606064;
        font-family: "Open Sans", sans-serif;
        font-size: 16px;
        letter-spacing: 0;
        line-height: 20px;
        text-align: center;
        @media (max-width: 768px) {
            text-align: left;
            font-size: 14px;
            font-family: "Open Sans", sans-serif;
        }
    }

    .tab-content {
        margin-top: 42px;

        .nav-link {
            font-family: Lato;
            font-size: 16px;
            font-weight: normal;
            letter-spacing: 0;
            line-height: 19px;
            text-align: center;
            border-bottom: 1px solid #808fa4;
            padding-bottom: 20px;
            color: #808FA4;

            &.active {
                color: #313131;
                font-weight: bold;

                &::after {
                    content: "";
                    border-bottom: 4px solid #ff375e;
                    width: 100%;
                    height: 100%;
                    position: absolute;
                    left: 0;
                    top: 0;
                }
            }
        }
    }
}
</style>
